import { useState, useEffect } from 'react';
import styled from 'styled-components';
import StateDropdownField from 'checkout/components/AddressForm/StateDropdownField';
import { AddressFormField } from 'checkout/components/AddressForm/AddressFormField';
import { getCountrySchemaFields } from 'checkout/utils/getCountrySchemaFields';
import { IAddressFormField } from 'checkout/types/AddressFormField';

export const AddressFormBySchema = ({ country, isPostalCodeRequired, onStateClick, state }) => {
  const [countrySchemaFields, setCountrySchemaFields] = useState<
    Array<IAddressFormField | IAddressFormField[]>
  >([]);

  useEffect(() => {
    if (country) {
      const fields = getCountrySchemaFields({
        isPostalCodeRequired,
        country: country.value,
      });

      setCountrySchemaFields(fields);
    }
  }, [country]);

  return (
    <>
      {countrySchemaFields.map((field) => {
        // Field may be array of fields to display as side-by-side fields rather than a plain stack
        if (Array.isArray(field)) {
          return (
            <AddressFormBySchema.Row>
              {field.map((subField) => {
                return (
                  <AddressFormBySchema.Col>
                    <AddressFormField
                      countryIsoCode={country?.value}
                      selectedState={state}
                      onMenuItemClick={onStateClick}
                      {...subField}
                    />
                  </AddressFormBySchema.Col>
                );
              })}
            </AddressFormBySchema.Row>
          );
        }
        return (
          <AddressFormField
            countryIsoCode={country?.value}
            selectedState={state}
            onMenuItemClick={onStateClick}
            {...field}
          />
        );
      })}
    </>
  );
};

AddressFormBySchema.Row = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: ${({ theme }) => theme.breakpoints.small}px) {
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;

    div:last-child {
      margin-bottom: 0px;
    }
  }
`;

AddressFormBySchema.Col = styled.div`
  width: 100%;

  @media (min-width: ${({ theme }) => theme.breakpoints.small}px) {
    width: 48%;
  }
`;

AddressFormBySchema.StateDropdownField = styled(StateDropdownField)`
  padding-bottom: 24px;
`;
